import React, { useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { AuthContext } from '../context/AuthContext';

// Load Stripe with the public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function ContinuePayment() {
  const { user, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const initiatePayment = async () => {
      if (!isAuthenticated || !user) {
        navigate('/login'); // Redirect if not logged in
        return;
      }

      try {
        // Create a checkout session for the user
        const paymentResponse = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/payment/create-checkout-session`,
          { plan: user.plan },
          { withCredentials: true }
        );

        // Redirect to the Stripe checkout page
        if (paymentResponse.data.id) {
          const stripe = await stripePromise; // Load Stripe instance
          if (!stripe) {
            throw new Error('Stripe failed to initialize');
          }
          await stripe.redirectToCheckout({ sessionId: paymentResponse.data.id });
        }
      } catch (err) {
        console.error('Error initiating payment:', err);
        navigate('/register'); // Redirect to registration if payment fails
      }
    };

    initiatePayment();
  }, [isAuthenticated, user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <h2 className="text-2xl font-bold text-center">Redirecting to payment...</h2>
    </div>
  );
}

export default ContinuePayment;
